import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import fr from 'facet-rest';
import {
  FDBodyText, FDContentContainer, FDPaper, FDStack,
} from '@facet-wealth/design';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import Typography from 'Components/UI/Typography';
import FinancialInstitutionList from './FinancialInstitutionList';
import SetupManually from './SetupManually';

const styles = (theme) => ({
  root: {
    ...wizardClasses.root(theme),
    flex: 1,
    margin: 'unset',
    width: '100%',
  },
  disclaimerText: {
    color: theme.palette.facet.primaryGray,
    ...theme.typography.body1,
  },
  specialInstructions: {
    ...theme.typography.body1,
  },
  title: {
    fontSize: 32,
    marginBottom: theme.spacing(2),
  },
  infoBoxRichText: {
    fontSize: '1rem',
    color: theme.palette.facet.primaryGray,
    lineHeight: '24px',
  },
});

const LinkOrAddAccountsContent = ({
  className,
  classes,
  resource,
  showAccountLinkingText,
  onLoadLink,
}) => {
  const theme = useTheme();
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <FDContentContainer maxWidth="sm">
        <FDStack direction="column" justifyContent="space-between" spacing={2}>
          <Typography
            className={classes.title}
            variant={'h1'}
            color={'primary'}
            weight={'medium'}
            align={'center'}
          >
            {resource.attr('title')}
          </Typography>
          {showAccountLinkingText ? <FDBodyText value={resource.attr('accountLinkingText')} color={'textDisabled'} align="center" /> : null}
          <FinancialInstitutionList
            institutions={[resource]}
            baseURLAttr="institutionBaseURL"
            iconAttr="institutionIcon"
            nameAttr="institutionName"
          />
          {resource.attr('accountLinkingSpecialInstructions') && (
          <FDPaper padding={2} color="subtle" appearance="flat">
            <div className={classes.specialInstructions}>
              <RichTextDisplay
                content={resource.attr('accountLinkingSpecialInstructions')}
              />
            </div>
          </FDPaper>
          )}
          <SetupManually resource={resource} onLoadLink={onLoadLink} />
          <Box sx={{ borderRadius: theme.radius.md, backgroundColor: theme.palette.facet.accentBlue20, padding: theme.spacing(2, 3) }}>
            <RichTextDisplay className={classes.infoBoxRichText} content={resource.attr('securityInfoText')} />
          </Box>
          <RichTextDisplay
            content={resource.attr('disclaimerText')}
            className={classes.disclaimerText}
          />
        </FDStack>
      </FDContentContainer>
    </Box>
  );
};

LinkOrAddAccountsContent.defaultProps = {
  className: '',
  showAccountLinkingText: true,
};

LinkOrAddAccountsContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onLoadLink: PropTypes.func.isRequired,
  showAccountLinkingText: PropTypes.bool, // This component should be refactored to utilize MetaControl so we can have a meta override for this
};

export default withStyles(styles)(LinkOrAddAccountsContent);
